"use strict";
exports.__esModule = true;
exports.NOT_ACCEPTING_PAYMENTS = void 0;
exports.NOT_ACCEPTING_PAYMENTS = {
    RENT_TRACKER: {
        HEADER: 'Your property is not accepting payments for your account',
        MAIN: 'Contact your property to request that they re-enable payments for your account. We’ll continue retrying every [12-24] hours until {{date}}.',
        CTA: 'View details'
    },
    HEADER: 'Your property is not accepting payments for your account',
    MAIN_TEXT_1: 'We attempted to pay your rent bill, but it appears that your property has disabled payments for your account.',
    MAIN_TEXT_2: 'We strongly encourage you to contact your property manager to request that they re-enable payments for your account.',
    BOLD_TEXT: 'We’ll continue to attempt to pay your rent bill up until {{date}}. ',
    CTA: 'Done'
};
